import { useEffect, useState } from 'react';
import { SimpleForm, TextInput, required, Edit, SelectInput, useDataProvider, TopToolbar, Toolbar, SaveButton } from 'react-admin';
import BackButton from '../../Components/BackButton';


const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

const PostEditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

// 添加电话号码校验
const validatePhone = (value: string) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (value) {
        if (!phoneRegex.test(value)) {
            return '请输入有效的手机号码';
        }
    }
    return undefined;
};

// 添加姓名校验
const validateName = (value: string) => {
    if (!value) {
        return '姓名是必填项';
    }

    const nameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9]{2,20}$/;
    if (!nameRegex.test(value)) {
        return '姓名只能包含中文、字母和数字，长度在2-20个字符之间';
    }
    return undefined;
};

export const userManageEdit = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [rolesTypes, setRolesTypes] = useState([]);

    useEffect(() => {
        const fetchRolesTypes = async () => {
            try {
                let types = await dataProvider.getRolesList();
                types = types.map((item: any) => ({
                    id: item.roleCode,
                    name: item.name
                }));
                setRolesTypes(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchRolesTypes();
    }, []);  // 空依赖数组确保只调用一次

    return (
        <Edit actions={<ActionsToolbar />} resource="userManage" mutationMode="optimistic" >
            <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} toolbar={<PostEditToolbar />}>
                <SelectInput label="角色编码" source="roleCode" choices={rolesTypes} validate={[required()]} />
                {/* <TextInput label="用户名" source="username" validate={[required()]} /> */}
                <TextInput label="联系电话" source="phone" validate={[validatePhone]} />
                <TextInput label="姓名" source="name" validate={[required(), validateName]} />
            </SimpleForm>
        </Edit>
    )
};